import VietnamPage from '@/components/pages/VietnamPage/VietnamPage'

const Vietnam = () => {
  return <VietnamPage />
}

export default Vietnam
